import { render, staticRenderFns } from "./PNCDetails.vue?vue&type=template&id=0c6d361e&scoped=true&"
import script from "./PNCDetails.vue?vue&type=script&lang=js&"
export * from "./PNCDetails.vue?vue&type=script&lang=js&"
import style0 from "./PNCDetails.vue?vue&type=style&index=0&id=0c6d361e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6d361e",
  null
  
)

export default component.exports